export const companyName = "MyTeenGig";
